import { CubeShapeIcon } from '@fluentui/react-icons-mdl2';

export interface LoadingSignProps {
  /** Loading message (default: "Loading ...") */
  message?: string;
  /** Icon element to display (default: CubeShapeIcon) */
  icon?: React.ReactNode;
  /** Width of the container (default: "100%") */
  width?: number | string;
  /** Height of the container (default: "100%") */
  height?: number | string;
}

const LoadingSign = ({
  message = 'Loading ...',
  icon,
  width = '100%',
  height = '100%',
}: LoadingSignProps) => {
  const defaultIcon = (
    <CubeShapeIcon style={{ fontSize: 125, color: 'lightgray' }} />
  );

  return (
    <div
      style={{
        width,
        height,
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <div style={{ flex: 'auto', position: 'relative' }}>
        <span
          style={{
            position: 'absolute',
            color: 'gray',
            top: '25%',
            left: '50%',
            transform: 'translateX(-50%)',
            fontSize: 20,
            fontWeight: 600,
          }}
        >
          {message}
        </span>
        {icon ?? defaultIcon}
      </div>
    </div>
  );
};

export default LoadingSign;
